import styled from "styled-components";

export const Wrapper = styled.section`
	display: flex;
	justify-content: center;
	p {
		margin: 0;
	}
`;
